const swiper = new Swiper('.js-company-swiper', {
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

NLMK.adaptiveBackgrounds();



// WEBPACK FOOTER //
// ./js/main/module/sliders/company-swiper.js